let content_blocks = require('../contents');

export function init(){
    
    $('#edit_external_video_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_external_video_modal').find('.btn.btn-danger.delete_media').each(function(){
        $(this).on('click', function() {
            let modal = $(this).closest('.modal');
            let block_id = modal.find('[name="block_id"]').val();
            let block = $('#'+ block_id);
            let media_id = block.attr('data-preview-media-id');
            content_blocks.delete_media(media_id);
            block.attr('data-preview-media-id', '');
            block.attr('data-preview-name', '');
            block.attr('data-preview-src', '');
        })
    });

    $('#edit_external_video_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="external_video"]').val(block.attr('data-src'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="width"]').val(block.attr('data-width'));
        modal.find('[name="height"]').val(block.attr('data-height'));
        modal.find('[name="alt"]').val(block.attr('data-alt'));
        modal.find('[name="controls"]').prop('checked', block.attr('data-controls') == 'true' ? true : false);
        modal.find('[name="autoplay"]').prop('checked', block.attr('data-autoplay') == 'true' ? true : false);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="type"]').val(block.attr('data-type'));
        
        let select_type = modal.find('[name="external_video_type"]');
        select_type.find('option[value="'+ block.attr('data-external-video-type') +'"]').prop('selected', true);
        select_type.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_align = modal.find('[name="align"]');
        select_align.find('option[value="'+ block.attr('data-align') +'"]').prop('selected', true);
        select_align.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let preview = modal.find('input[name="preview"]');
        let label_preview = preview.next('label');
        label_preview.text(block.attr('data-preview-name'));

    });

    $('#edit_external_video').on('submit', function (e) {
        e.preventDefault();

        let block = $('#'+ $(this).find('[name="block_id"]').val());

        block.attr('data-external-video-type', $(this).find('[name="external_video_type"]').val());
        block.attr('data-src', $(this).find('[name="external_video"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-width', $(this).find('[name="width"]').val());
        block.attr('data-height', $(this).find('[name="height"]').val());
        block.attr('data-alt', $(this).find('[name="alt"]').val());
        block.attr('data-align', $(this).find('[name="align"]').val());
        block.attr('data-controls', $(this).find('[name="controls"]').prop('checked'));
        block.attr('data-autoplay', $(this).find('[name="autoplay"]').prop('checked'));
        
        let modal = $(this).closest('.modal');
        modal.modal('hide');

        let form_data = new FormData($(this)[0]);

        update_content_external_video(form_data, block);
        content_blocks.change_visible_button_blocks(block);

        let card_body = block.find('.card-body');
        card_body.removeClass();
        card_body.addClass(['card-body', 'd-flex','justify-content-'+form_data.get('align')]);
        
        $(this)[0].reset();

    });

    $('.block[data-type="external_video"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })

    function update_content_external_video(form_data, block) {
        let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

        form_data.append('type', block.attr('data-type'));
        window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null) {
                    block.attr('data-src', response.data.src);
                    block.attr('data-preview-src', response.data.preview_src);
                    block.attr('data-preview-name', response.data.preview_name);
                    block.attr('data-preview-media-id', response.data.preview_media_id);
                    update_preview_container(block);
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
    }

    function update_preview_container(block) {
        let type = block.attr('data-external-video-type');
        let preview_src = block.attr('data-preview-src');
        let preview_name = block.attr('data-preview-name');
        let src = block.attr('data-src');

        let car_body = block.find('.card-body');
        if (preview_src != '' && preview_src != null) {
            let div = '<a class="d-flex justify-content-center" href="'+ ( src != '' ? src : '') + '">'+
            '<img'+ 
            ' style="max-width: 50%"'+
            ' src="'+ (preview_src != '' ? preview_src : '') +'"'+
            ' alt="'+ (preview_name ? preview_name : '')+'">'
            '</a>';

            car_body.html(div);
        } else {
            if (type == 'vimeo') {
                let div = '<a href="'+ ( src != '' ? src : '') + '" class="btn btn-lg">'+
                    '<i'+ 
                    ' class="fa-brands fa-vimeo fa-2xl"'+
                    ' style="color: #17d5ff;"'+
                    '</i>'+
                '</a>';

                car_body.html(div);
            } else {
                let div = '<a href="'+ ( src != '' ? src : '') + '" class="btn btn-lg">'+
                '<i'+ 
                ' class="fa-brands fa-youtube fa-2xl"'+
                ' style="color: #f40606;"'+
                '</i>'+
                '</a>';

                car_body.html(div);
            }
        }
    }
}